import React, { useEffect, useState, useRef, forwardRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Utils,ElementVisibilityChecker } from '../../Utils.js';
import i18n from '../../i18n/i18n.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { ReactSVG } from "react-svg";
import { motion } from "framer-motion"
import TypedLink from '../../components/TypedLink/TypedLink.js';
import ProductListItem from '../../components/ProductListItem/ProductListItem.js';
import ProuctsFilters from '../../components/ProductsFilters/ProductsFilters.js';
import ProductSignatures from '../../components/ProductSignatures/ProductSignatures.js';
//import RecommendedProducts from '../../components/RecommendedProducts/RecommendedProducts.js';
import './Products.css';


const Products = forwardRef(function(props, ref) {

    const ProductsListRef = useRef();
    const ProductsFilterRef = useRef();

    const location = useLocation();
    const [serverData, setServerData] = useState({runs: 0}); // runs: kell egy változó érték a render legfelső dom eleméhez, mert enélkül a useState soha nem érhet véget... (nem fut le a render, hiába változott a serverData)
    const [scrollTo, setScrollTo] = useState(0);
    const [filterClicked, setFilterClicked] = useState({clicked:0});
    const [filterVisible, setFilterVisible] = useState({visible:0});
    const [filterAnimation, setFilterAnimation] = useState({animate:1});
    const [loadMore,setLoadMore] = useState({loading:0});

    let loading = 0;

    useEffect(() => {

        setServerData({runs: 0, loaded:0})

        const cache_data = check_back_cache();

        if(cache_data && Object.keys(cache_data).length>0 && cache_data.serverData){
            setServerData( cache_data.serverData);
            if(cache_data.scrollPosTop){
                setScrollTo(cache_data.scrollPosTop);
            }
        }else{
            get_product_list_from_api({},()=>{
                load_categories_filter()
            });
        }

    }, [location]);

    const set_product_list_order_by = (set_to)=>{
        setFilterAnimation({animate:0});
        delete_back_cache();
        get_product_list_from_api({products_order_by:set_to});
    }

    const load_categories_filter = ()=>{
        get_product_list_from_api({get_filter_categories:true});
    }

    const get_product_list_from_api = (post_data,cb)=>{

        let query_string = { APICACHE: true };
        const search_params = Object.fromEntries(new URLSearchParams(location.search));
        const post = (post_data) ? post_data : {};

        if(Object.keys(search_params).length>0){
            query_string = {...query_string,...search_params};
        }
        
        Utils.get_server_data(location.pathname, query_string, post).then((resp) => {
            resp.runs = 0;
            
            if(post_data && post_data.get_filters){
                setFilterAnimation({animate:0});
            }else{
                setServerData(resp);
                setFilterClicked({clicked:0});
            }
            
            if(cb && typeof cb == 'function'){
                cb(resp);
            }
        });

    }

    const scroll_list_to = ()=>{
        setTimeout(()=>{
            document.querySelector('.product_list_inner').scrollTo(0,scrollTo);
            setScrollTo(0);
        },300)
    }
   
    const clickSetFilterVisible = (set_to) =>{

        if(set_to===1){
            setFilterClicked({'clicked':1});
        }

        filterVisible.visible = set_to;
        setFilterVisible({...filterVisible});
    }

    function load_more_products(loading_button)
    {
        const products = serverData.products.list.products;
        const products_paged_url = '/products'+serverData.pager.next;

        if(loading===0){

            loading = 1;
            setLoadMore({loading:1});
            
            Utils.get_server_data(products_paged_url).then((resp) => {

                const page_products = resp.products.list.products;
                products.push.apply(products, page_products);
                resp.products.list.products = products;

                resp.runs = serverData.runs + 1;
                setServerData(resp);
                loading=0;
                setLoadMore({loading:0});
                             
            })


        }
            
    }

    function delete_back_cache()
    {
        let cache_data =  localStorage.getItem('back_cache');
        if(cache_data){
            localStorage.removeItem('back_cache');
        }
    }

    function check_back_cache()
    {
        let cache_data =  localStorage.getItem('back_cache');
        cache_data = JSON.parse(cache_data);


        if(cache_data && Object.keys(cache_data).length>0 && cache_data.urlHash && cache_data.timestamp)
        {
            const timestamp = Math.floor(Date.now() / 1000);

            //csak ha ugyan az az url és kevesebb mint 10 perc telt el
            if(btoa(location.pathname) === cache_data.urlHash && timestamp-cache_data.timestamp<300)
            {
                return cache_data;
            }
        }
    }

    const set_list_back_cache = (e, product) =>{

        const timestamp = Math.floor(Date.now() / 1000);
        const scroller = document.querySelector(".product_list_inner");

        const cache_data = {
            'serverData':serverData,
            'urlHash': btoa(location.pathname),
            'timestamp': timestamp,
            'scrollPosTop':scroller.scrollTop
        };

        try {
            localStorage.setItem('back_cache',JSON.stringify(cache_data));
        } catch (error) {
            console.warn(error);
        }
    }

    function render_top_category_select() {

            return <div className='prpduct_list_cat_select_top_cont'>
                {
                (serverData?.list_settings?.filters?.next_lvl_categories!==undefined && Object.keys(serverData?.list_settings?.filters?.next_lvl_categories).length>0) ? 
                <motion.ul
                initial={{ opacity: 0}}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }} 
                className='prpduct_list_cat_select_top'>
                    {Object.entries(serverData?.list_settings?.filters?.next_lvl_categories).map(function(val,index){
                        return <li key={val[0]}><TypedLink link={{ type: 'products', url: val[1].url, title: val[1].label }} /></li>
                    })}
                </motion.ul>
                : ''}
                
            </div>

    }

    return (
        <>
            <>{filterClicked.clicked && serverData.loaded===1 ?  
                <ProuctsFilters
                isVisible={filterVisible.visible}
                hideFromParent={clickSetFilterVisible} 
                setProductsOrderBy={set_product_list_order_by}
                loadProductList={get_product_list_from_api}
                filterAnimation={filterAnimation.animate}
                ></ProuctsFilters> : ''}</>

            <div className={`container floating_container products_list`}>
            {
                serverData.loaded===1
                ?
                    (serverData.products) ? <>
                        {/*<PageHeader isHistoryBack="true" parent_ref={this} no_close="true" title={(serverData.title) ? serverData.title : i18n.t('productListDefaultTitle')} ></PageHeader>*/}
                        <PageHeader isHistoryBack="true"  no_close="true" custom_icons={[<ReactSVG onClick={()=>{clickSetFilterVisible(1)}} className="filter_icon" src="assets/images/filter.svg" />]} title={(serverData.title) ? serverData.title : i18n.t('productListDefaultTitle')}></PageHeader>
                        
                        {serverData.signatures || serverData.percentage_discont ? '' : render_top_category_select()}
                        
                        <div className={"product_list_inner" +  (serverData.signatures || serverData.percentage_discont ? ' no_categories' : '')}>
                            {serverData.signatures  ? <ProductSignatures signaturesData={serverData.signatures}></ProductSignatures> : ''}
                            {serverData.percentage_discont ? <div className='percentage_discount_details_cont' dangerouslySetInnerHTML={{__html:serverData.percentage_discont.description}}></div> : ''}
                            {/*<HeaderBanner text="Ingyenes szállítás 14 999 Ft felett" url="/szallitas" url-type=""></HeaderBanner>*/}
                            {/*<RecommendedProducts></RecommendedProducts>*/}
                            <div className='product-list-items-cont'>
                                {serverData.products.list && serverData.products.list.products.map((product, index) => {
                                    product.index = index + 1;

                                    return <ProductListItem 
                                            parentFunction={set_list_back_cache} 
                                            ref={ProductsListRef} key={`${product.id + '_' + serverData.runs}`} 
                                            product={product} 
                                        />})}    
                            </div>
                            
                            {(serverData.pager.next) ? <div key={serverData.pager.next} className='load_products_cont'><ElementVisibilityChecker onVisible={(c)=>{load_more_products(c)}}><div className={"load-more-roducts"+((loadMore.loading==1) ? " loading" : '')}>{i18n.t('productListLoadMore')}</div></ElementVisibilityChecker></div> : ''}
                        </div>
                        {scrollTo ? scroll_list_to() : ''}
                    </>
                    : <>
                        <PageHeader key={serverData.title} isHistoryBack="true" parent_ref={this} no_close="true" title='404'></PageHeader>
                        <div className='product_list_inner'><div className='empty_list_msg'>{i18n.t('productListEmptyListMsg')}</div></div>
                    </>
                :
                <div className='loader_cont'><div className='loader'><ReactSVG src='assets/images/dorko_loader.svg'></ReactSVG></div></div>
            }
            
            </div>
        </>
    );

});

export default Products;